import { notifyBugsnag } from "@common/utils/initBugsnag"
import { exitForStatus } from "../../engine/live/room/roomMachine"

/**
 * Ce que la salle du live dit à Bugsnag quand le serveur ne la sert pas (`getLiveSessionV2`).
 * Un refus (pas le bon jour, paiement en attente, séance disparue : la même lecture que le live de
 * l'élève du design system) applique une règle : il est compté en `info`, un groupe par refus,
 * stable d'un déploiement à l'autre. Le reste est un défaut.
 */
export function reportLiveRoomFailure(error) {
    const message = error?.message ?? error?.error
    const exit = exitForStatus(error?.status)
    if (exit == null) {
        notifyBugsnag("getLiveSession error: " + message)
        return
    }
    notifyBugsnag(
        new Error(`Salle du live refusée (${exit})`),
        { message },
        { severity: "info", groupingHash: `live-room-refused-${exit}` }
    )
}
